import { render, staticRenderFns } from "./InjectedObjectEvidenceListDialog.vue?vue&type=template&id=1a89a7f6&scoped=true&"
import script from "./InjectedObjectEvidenceListDialog.vue?vue&type=script&lang=ts&"
export * from "./InjectedObjectEvidenceListDialog.vue?vue&type=script&lang=ts&"
import style0 from "./InjectedObjectEvidenceListDialog.vue?vue&type=style&index=0&id=1a89a7f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a89a7f6",
  null
  
)

export default component.exports